import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import SignOutButton from './SignOutButton';
import CartIcon from './CartIcon';
import { useAuth } from '../AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../translations';

function Navbar() {
  const { currentUser, isMember } = useAuth();
  const { language, toggleLanguage } = useLanguage();
  const location = useLocation();
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  useEffect(() => { closeMobileMenu(); /* eslint-disable-next-line */ }, [location.pathname]);

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  return (
    <div className="navbar-wrapper">
      <nav className="navbar">
        <div className="navbar-container">
          {!click && (
            <button
            className="menu-button"
            onClick={handleClick}
            aria-expanded={click}
            aria-label={click ? 'Close menu' : 'Open menu'}
            >
            {!click ? (
                <img src="/icons/burger.png" alt="Menu" />
            ) : (
                <span aria-hidden="true">×</span>
            )}
            </button>

          )}

          <Link to="/" className="navbar-logo" onClick={closeMobileMenu} aria-label="Home">
            <img src="/icons/ideafarm_logo_2026.png" alt="Idea Farm logo" />
          </Link>

          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
  {click && (
    <li className="nav-item mobile-home-row">
      <Link to="/" className={`nav-links ${isActive('/')}`} onClick={closeMobileMenu}>
        {t('nav.home', language)}
      </Link>
      <button
        className="mobile-menu-close"
        onClick={closeMobileMenu}
        aria-label="Close menu"
      >
        ×
      </button>
    </li>
  )}

  <li className="nav-item">
    <Link to="/events" className={`nav-links ${isActive('/events')}`} onClick={closeMobileMenu}>
      {t('nav.events', language)}
    </Link>
  </li>
  <li className="nav-item">
    <Link to="/recording" className={`nav-links ${isActive('/recording')}`} onClick={closeMobileMenu}>
      {t('nav.recording', language)}
    </Link>
  </li>
  <li className="nav-item">
    <Link to="/labs" className={`nav-links ${isActive('/labs')}`} onClick={closeMobileMenu}>
      {t('nav.labs', language)}
    </Link>
  </li>
  <li className="nav-item">
    <Link to="/hire" className={`nav-links ${isActive('/hire')}`} onClick={closeMobileMenu}>
      {t('nav.hire', language)}
    </Link>
  </li>
  <li className="nav-item">
    <Link to="/accommodation" className={`nav-links ${isActive('/accommodation')}`} onClick={closeMobileMenu}>
      {t('nav.accommodation', language)}
    </Link>
  </li>
  <li className="nav-item">
    <Link to="/shop" className={`nav-links ${isActive('/shop')}`} onClick={closeMobileMenu}>
      {t('nav.shop', language)}
    </Link>
  </li>

  <li className="nav-item">
    <Link to="/contact" className={`nav-links ${isActive('/contact')}`} onClick={closeMobileMenu}>
      {t('nav.info', language)}
    </Link>
  </li>
</ul>

            <div className="navbar-right">
              <div className="navbar-right-top">
                <div className="basket-anchor">
                  <CartIcon
                      emptySrc="/icons/cart-empty.png"
                      fullSrc="/icons/cart-full.png"
                  />
                </div>
                <button
                  onClick={toggleLanguage}
                  className="lang-toggle"
                  aria-label={language === 'en' ? 'Switch to Swedish' : 'Switch to English'}
                >
                  {language === 'en' ? 'SV' : 'EN'}
                </button>
              </div>
              {/* Auth button hidden for now — uncomment to restore for membership perks */}
              {/* <div className="navbar-right-bottom">
                {currentUser ? (
                  <SignOutButton className="nav-links nav-links--auth" />
                ) : (
                  <Link to="/auth" className={`nav-links nav-links--auth ${isActive('/auth')}`} onClick={closeMobileMenu}>
                    {t('nav.login', language)}
                  </Link>
                )}
              </div> */}
            </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
